module.exports = __webpack_public_path__ + "img/feedback_removal.svg";